import React, {Component} from 'react';
import {connect} from 'react-redux';
import SingleBetGameCard from '../components/singleBetGameCard.js';
import {sortRacers} from '../helpers/sortingHelper';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        selectedRaceCardSortField: state.vpp.selectedRaceCardSortField
    };
};

class RacersListSingleBets extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState(
                {
                    selectedEventIndex: storeData.vpp.selectedEventIndex,
                    events: storeData.vpp.events,
                    selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField
                }
            );
        }
    }

    render() {

        return (<div>{this._getListOfSingleBetsCardsUI()}</div>);
    }

    _getListOfSingleBetsCardsUI() {
        let listOfSingleBetsCardsUI = [];
        if (this.state.events.length > 0) {
            let listOfSingleBetsCards = this.state.events[this.state.selectedEventIndex].racers.sort(sortRacers.bind(this.state));

            listOfSingleBetsCardsUI = listOfSingleBetsCards.map((racer, index) => {
                return (
                    <SingleBetGameCard
                        key={index}
                        game={this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex]}
                        index={index}
                        racer={racer}
                        marketNum={racer.num}
                        store={this.props.store}
                        isLast={index === listOfSingleBetsCards.length - 1}/>
                );
            });

        }
        return listOfSingleBetsCardsUI;
    }

}

export default connect(mapStateToProps)(RacersListSingleBets);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/containers/racersListSingleBets.js